import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '@tytapp/common';
import { Playback } from '../playback/playback';
import { ApiPlaybackSession, ApiPodcast, ApiProduction, ApiVOD } from '@tytapp/api';
import { Subject } from 'rxjs';

@Component({
    selector: 'tyt-playback-status-bar',
    templateUrl: './playback-status-bar.component.html',
    styleUrls: ['./playback-status-bar.component.scss']
})
export class PlaybackStatusBarComponent extends BaseComponent {

    constructor(
        private playback: Playback
    ) {
        super();
    }

    @Output()
    resumable: Subject<boolean> = new Subject<boolean>();

    @Input()
    item: ApiPodcast | ApiVOD;

    @Input()
    itemId: string;

    @Input()
    playlist: string;

    @Input()
    production: ApiProduction;

    @Output()
    sessionChanged: Subject<ApiPlaybackSession> = new Subject<ApiPlaybackSession>();

    @Input()
    session: ApiPlaybackSession;

    get active() {
        let shown = false;
        if (this.session) {
            shown = true;
            if (this.visibility === 'threshold')
                shown = this.session.position > 5;
        }

        return shown;
    }

    get filledPercent() {
        if (!this.session || this.session.duration == 0)
            return undefined;

        return Math.round(this.session.position / this.session.duration * 100) + '%';
    }

    @Input()
    visibility: 'threshold' | 'always' = 'threshold';

    async init() {
        // Only show playback status bars client-side.
        if (typeof window === 'undefined')
            return;

        let id: string;

        if (this.item || this.itemId) {
            if (this.item)
                id = this.item.id;
            else
                id = this.itemId;

            this.session = await this.playback.getSessionForId(id);
            this.sessionChanged.next(this.session);


            this.resumable.next(this.active);
        }
    }
}
